interface IAssetIconEntry {
  promise: Promise<string | null>;
  url: string | null;
}

const cache = new Map<string, IAssetIconEntry>();

const listeners = new Set<() => void>();

const notify = (): void => {
  listeners.forEach((listener) => listener());
};

const subscribe = (listener: () => void): (() => void) => {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
};

const get = (
  assetTypeCode: string,
  fetcher: () => Promise<Blob | null>,
): Promise<string | null> => {
  const existing = cache.get(assetTypeCode);
  if (existing) {
    return existing.promise;
  }

  const promise = fetcher().then((blob) => {
    const url = blob ? URL.createObjectURL(blob) : null;
    const entry = cache.get(assetTypeCode);
    if (entry) {
      entry.url = url;
    }
    return url;
  });

  cache.set(assetTypeCode, { promise, url: null });
  return promise;
};

const invalidate = (assetTypeCode: string): void => {
  const entry = cache.get(assetTypeCode);
  if (entry?.url) {
    URL.revokeObjectURL(entry.url);
  }
  cache.delete(assetTypeCode);
  notify();
};

const clear = (): void => {
  cache.forEach((entry) => {
    if (entry.url) {
      URL.revokeObjectURL(entry.url);
    }
  });
  cache.clear();
  notify();
};

export const assetIconCache = {
  get, invalidate, clear, subscribe,
};
